import { readonly, ref } from 'vue';

// Shows the top loading bar while the router waits for a page (its lazy chunk, an async guard).
// Fast navigations never show it: the bar appears only once one takes longer than SHOW_AFTER_MS.
export const SHOW_AFTER_MS = 150;

const isVisible = ref(false);
let showTimer: ReturnType<typeof setTimeout> | null = null;

export const isNavigationInProgress = readonly(isVisible);

export const startNavigationProgress = (): void => {
  if (showTimer) clearTimeout(showTimer);
  showTimer = setTimeout(() => {
    isVisible.value = true;
  }, SHOW_AFTER_MS);
};

export const endNavigationProgress = (): void => {
  if (showTimer) clearTimeout(showTimer);
  showTimer = null;
  isVisible.value = false;
};
